// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ⬇️ AJOUT DE L'IMPORT POUR INITIALISER i18next
// Assurez-vous que votre fichier i18n.js exporte par défaut l'instance i18n.
import i18n from './i18n'; // 👈 On importe l'instance de i18n
import { I18nextProvider } from 'react-i18next'; // 👈 On importe le Provider
// ------------------------------------------------
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        {/* 🛑 CORRECTION ICI : On enveloppe l'application avec I18nextProvider */}
        <I18nextProvider i18n={i18n}>
            <App />
        </I18nextProvider>
    </React.StrictMode>
);

// Pour que votre application fonctionne hors ligne et se charge plus rapidement, 
// passez en revue et activez le Service Worker. En savoir plus : https://cra.link/PWA
serviceWorkerRegistration.register();

// Si vous voulez commencer à mesurer la performance de votre application,
// passez une fonction pour enregistrer les résultats
// (par exemple: reportWebVitals(console.log))
// ou l'envoyer à un endpoint d'analyse. En savoir plus : https://bit.ly/CRA-vitals
reportWebVitals();